export default __webpack_public_path__ + "static/media/fundo_mioloe.a38f1982.png";